import React, { useState } from "react";
import styles from "./Order.module.css";
import { useLocation } from "react-router-dom";
import { Modal, SubmitButton, TextComponent } from "../../../../components";
import { TiMinus, TiPlus } from "react-icons/ti";
import { List } from "antd";
import productImg1 from "../../../../assets/images/staticImages/md1.png";
import productImg2 from "../../../../assets/images/staticImages/md2.png";
import productImg3 from "../../../../assets/images/staticImages/md3.png";
import { PiSealCheck } from "react-icons/pi";
const Order = () => {
  const [successModal, setSuccessModal] = useState(false);
  const { state } = useLocation();
  const [count, setCount] = useState(0);
  const dummyProducts = [
    {
      id: 1,
      image: productImg1,
      name: "Phoenix Immobilizer N16",
      items: "100",
    },
    {
      id: 2,
      image: productImg2,
      name: "Dragon Shield S20",
      items: "100",
    },
    {
      id: 1,
      image: productImg3,
      name: "Griffin Gauntlet G12",
      items: "100",
    },
    {
      id: 1,
      image: productImg1,
      name: "Phoenix Immobilizer N16 Phoenix Immobilizer N16",
      items: "100",
    },
    {
      id: 2,
      image: productImg2,
      name: "Dragon Shield S20",
      items: "100",
    },
    {
      id: 1,
      image: productImg3,
      name: "Griffin Gauntlet G12",
      items: "100",
    },
    {
      id: 1,
      image: productImg1,
      name: "Phoenix Immobilizer N16",
    },
    {
      id: 2,
      image: productImg2,
      name: "Dragon Shield S20",
    },
    {
      id: 1,
      image: productImg3,
      name: "Griffin Gauntlet G12",
    },
    {
      id: 1,
      image: productImg1,
      name: "Phoenix Immobilizer N16 Phoenix Immobilizer N16",
    },
    {
      id: 2,
      image: productImg2,
      name: "Dragon Shield S20",
    },
    {
      id: 1,
      image: productImg3,
      name: "Griffin Gauntlet G12",
    },
  ];
  return (
    <div className={styles.orderMainCont}>
      <div className={styles.orderLeftCont}>
        <img src={state?.item?.image} />
      </div>
      <div className={styles.orderRightCont}>
        <div className={styles.orderRight_sub}>
          <TextComponent
            text={state?.item?.name}
            style={{
              fontFamily: "Urbanist-bold",
              fontSize: "var(--dashboard_tabs-font-size)",
            }}
          />
          <TextComponent
            text={
              "Introducing the Phoenix Immobilizer N16, a cutting-edge security device designed to protect your vehicle from theft. With advanced technology and user-friendly features, the N16 ensures that your car remains safe and secure. Its sleek design seamlessly integrates with your vehicle's systems, providing peace of mind without compromising style. Whether you're parked at home or on the go, the Phoenix Immobilizer N16 is your reliable partner in vehicle protection."
            }
            style={{
              margin: "10px 0",
            }}
          />
          {state?.status == "pendingOrder" || state?.status == "reOrder" ? (
            <div style={{display: "flex", flexDirection: "column"}}>
              <TextComponent
                text={"Details"}
                style={{
                  color: "var(--light-grey)",
                  fontFamily: "Urbanist-bold",
                  fontSize: "var(--mobile-heading)",
                  marginTop: "10px"
                }}
              />
              <TextComponent className={styles.order_text} text={"Quantity: "}><text style={{fontFamily: "Urbanist-bold"}}>100 Units</text></TextComponent>
              <TextComponent className={styles.order_text} text={"Date: "}><text style={{fontFamily: "Urbanist-bold"}}>Jan 12, 2024</text></TextComponent>
              <TextComponent className={styles.order_text} text={"Price per unit: "}><text style={{fontFamily: "Urbanist-bold"}}>-----</text></TextComponent>
              <TextComponent className={styles.order_text} text={"Total price: "}><text style={{fontFamily: "Urbanist-bold"}}>-----</text></TextComponent>
            </div>
          ) : (
            <div className={styles.countBtn}>
              <TiMinus
                className={styles.countIcon}
                onClick={() => {
                  count > 0 && setCount(count - 1);
                }}
              />
              <TextComponent
                text={count}
                style={{
                  fontFamily: "Urbanist-bold",
                  fontSize: "var(--heading2-font-size)",
                }}
              />
              <TiPlus
                className={styles.countIcon}
                onClick={() => setCount(count + 1)}
              />
            </div>
          )}
          {state?.status != "pendingOrder" && (
            <SubmitButton
              onClick={() => setSuccessModal(true)}
              title={state?.status == "reOrder" ? "Re-Order" : "Send Inquiry"}
              btnClass={styles.sendInquiryBtn}
            />
          )}
        </div>
        {state?.status == "reOrder" ||
        state?.status == "pendingOrder" ? null : (
          <div className={styles.orderRight_sub}>
            <TextComponent
              text={"More for you"}
              style={{
                fontFamily: "Urbanist-bold",
                fontSize: "var(--dashboard_tabs-font-size)",
              }}
            />
            <div className={styles.listMainCont}>
              <List
                dataSource={dummyProducts}
                className={styles.list}
                grid={{ gutter: 16, column: 2, xs: 1 }}
                renderItem={(item, index) => (
                  <div className={styles.products_listItem}>
                    <img
                      className={styles.products_listImg}
                      src={item?.image}
                    />
                    <TextComponent
                      text={item?.name}
                      className={styles.products_listText}
                    />
                    <div className={styles.products_listBtnDiv}>
                      <SubmitButton
                        title={"Order now"}
                        textStyle={{ fontFamily: "Urbanist-regular" }}
                        btnClass={styles.products_listBtn}
                      />
                    </div>
                  </div>
                )}
              />
            </div>
          </div>
        )}
      </div>

      <Modal
        open={successModal}
        onCancel={() => setSuccessModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Query Sent Successfully"}
        width={"400px"}
        buttonTitle={"Continue"}
        onBtnPress={() => {
          setSuccessModal(false);
        }}
        headingClass={styles.modalHeading}
      ></Modal>
    </div>
  );
};

export default Order;
